import { render, staticRenderFns } from "./LocationDeniedPage.vue?vue&type=template&id=61065a88&scoped=true"
import script from "./LocationDeniedPage.vue?vue&type=script&lang=js"
export * from "./LocationDeniedPage.vue?vue&type=script&lang=js"
import style0 from "./LocationDeniedPage.vue?vue&type=style&index=0&id=61065a88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61065a88",
  null
  
)

export default component.exports